export function hostname() {
    //let webappname = 'fandom-webapp/';
    let webappname = '';
    let url = window.location.protocol + '//' + window.location.hostname + '/' + webappname;
    return url;
}
